import React from 'react';
import { StarIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { GoldButton } from '../ui/GoldButton';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/mSfcMCCEeNw9H1rYcX3LR3/mockupglucosaestable.png';
const badges = ['Garantía 60 días', 'Acceso inmediato', 'Pago único'];
const EASE = [0.23, 1, 0.32, 1] as const;
function Mockup({
  className = ''
}: {
  className?: string;
}) {
  return <img src={MOCKUP_URL} alt="Tablet sobre una mesada de cocina mostrando la portada del ebook Método Glucosa Estable" className={`w-full rounded-2xl shadow-[0_28px_60px_-24px_rgba(26,71,42,0.45)] ${className}`} width={1024} height={1024} loading="eager" data-id="element-111" data-mp="mts9eppik6f7" />;
}
export function Hero() {
  const reduceMotion = useReducedMotion();
  const fade = (delay: number) => reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.32,
      delay,
      ease: EASE
    }
  };
  return <header className="w-full overflow-hidden bg-[linear-gradient(180deg,#f8f9fa_0%,#ffffff_72%)]" data-id="element-112" data-mp="9ou9tz528zxi">
      <div className="mx-auto grid w-full max-w-container items-center gap-10 px-5 pb-12 pt-10 sm:px-8 lg:grid-cols-[3fr_2fr] lg:gap-10 lg:pb-24 lg:pt-20" style={{
      paddingBottom: "36px"
    }} data-id="element-113" data-mp="4nofjwvr54lv">
        <div className="flex flex-col" data-id="element-114" data-mp="3ru78tij7038w">
          <motion.p className="mb-5 inline-flex self-start rounded-full border border-gold/60 bg-white px-4 py-1.5 text-[0.65rem] font-bold uppercase tracking-[0.16em] text-forest sm:text-xs" {...fade(0)} data-id="element-115" data-mp="3rvig3sbujt4r">
            Método Glucosa Estable: el código anti-antojos
          </motion.p>

          <motion.h1 className="text-[2.1rem] font-black leading-[1.08] tracking-tight text-forest sm:text-5xl lg:text-[3.5rem]" {...fade(0.05)} data-id="element-116" data-mp="imxu6s4b7qnq">
            Dile adiós a los antojos y recupera tu energía en solo 7 días
          </motion.h1>

          <motion.p className="mt-6 max-w-xl text-[1.0625rem] leading-relaxed text-body sm:text-[1.2rem]" {...fade(0.1)} data-id="element-117" data-mp="16ebqta9hu8ei">
            Descubre la ciencia de la secuenciación de alimentos: el orden exacto para aplanar tu
            curva de glucosa y activar tu metabolismo{' '}
            <strong className="font-semibold text-ink" data-id="element-118" data-mp="35mutuh0k2uvk">sin dejar de comer lo que amas</strong>.
          </motion.p>

          {/* Móvil: el mockup vive entre el texto y el botón */}
          <motion.div className="mx-auto mt-8 w-full max-w-[320px] lg:hidden" {...reduceMotion ? {} : {
          initial: {
            opacity: 0,
            y: 20,
            scale: 0.97
          },
          animate: {
            opacity: 1,
            y: 0,
            scale: 1
          },
          transition: {
            duration: 0.34,
            delay: 0.14,
            ease: EASE
          }
        }} data-id="element-119" data-mp="2vte4bp7gc1xp">
            <Mockup data-id="element-120" data-mp="2cxe63wnvs25o" />
          </motion.div>

          <motion.div className="mt-8" {...fade(0.2)} data-id="element-121" data-mp="2cyfkaa0714rm">
            <GoldButton href="#comprar" data-id="element-122" data-mp="66yaks6ojql6">Sí, Quiero Mi Mapa Ahora</GoldButton>
          </motion.div>

          <motion.p className="mt-4 flex items-center justify-center gap-2 text-sm font-medium text-ink sm:justify-start" {...fade(0.24)} data-id="element-123" data-mp="b3x2r56s9ngq">
            <StarIcon className="h-4 w-4 shrink-0 fill-gold text-gold" aria-hidden="true" data-id="element-124" data-mp="1vkxwsy3elfnx" />
            +5.000 mujeres han estabilizado su metabolismo este mes.
          </motion.p>

          
        </div>

        {/* Desktop: mockup más grande, con sombra y forma orgánica detrás */}
        <motion.div className="relative hidden justify-self-center lg:block" {...reduceMotion ? {} : {
        initial: {
          opacity: 0,
          scale: 0.97
        },
        animate: {
          opacity: 1,
          scale: 1
        },
        transition: {
          duration: 0.34,
          delay: 0.1,
          ease: EASE
        }
      }} data-id="element-125" data-mp="20ksk6rnyzn48">
          <span className="absolute -inset-12 -z-10 rounded-full bg-cream blur-2xl" aria-hidden="true" data-id="element-126" data-mp="2oawlgsdoras2" />
          <Mockup className="relative w-[130%] max-w-none -translate-x-[8%]" data-id="element-127" data-mp="2jaid19869yti" />
        </motion.div>
      </div>
    </header>;
}